<template>
  <md-card v-if="previousQuotes.length > 0">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="card-icon">
        <md-icon>{{ quoteIcon }}</md-icon>
      </div>
      <h4 class="title">Previous Quotes</h4>
    </md-card-header>
    <md-card-content>
      <md-card
        v-for="quote in previousQuotes"
        :key="quote.id"
        :value="quote.id"
      >
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-33">
              <p>
                <strong>Value:</strong>
                <br />
                &#163;{{ quote.value }}
              </p>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-33">
              <p>
                <strong>Priority:</strong>
                <br />
                {{ quotePriority(quote.quotePriority).name }}
              </p>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-33">
              <p v-bind:class="'text-' + quoteStatus(quote.quoteStatus).colour">
                <strong>Status:</strong>
                <br />
                {{ quoteStatus(quote.quoteStatus).name }}
              </p>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <strong>Created:</strong>
              <br />
              <i
                >{{ quote.createdDate | moment("MMMM Do YYYY HH:mm") }} -
                {{ quote.createdBy }}
              </i>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <strong>Last Updated:</strong>
              <br />
              <i
                >{{ quote.lastUpdatedDate | moment("MMMM Do YYYY HH:mm") }} -
                {{ quote.lastUpdatedBy }}
              </i>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </md-card-content>
  </md-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      quoteIcon: "quote/icon",
      quoteStatus: "quote/getQuoteStatus",
      quotePriority: "quote/getQuotePriority",
      previousQuotes: "quote/getPreviousQuotes"
    })
  }
};
</script>

<style></style>
